export function getEntryIDFromPath(path) {
  // parse entryID from path variable
  return path?.split("/")[2];
}

export function getCategoryIDFromPath(path) {
  // parse categoryID from path variable
  return path?.split("/")[2];
}

// Get a destination path based on the actual item and styleID
export function getDest(item, styleID, fromHome = false) {
  const actualStyleID = styleID.value ?? styleID;

  const queryParam = fromHome ? "?fromHome=true" : "";

  if (item.path) {
    if (item.categoryID && !item.hasSubCategories) {
      return `/entry/${actualStyleID}/${item.categoryID}/${getEntryIDFromPath(
        item.path
      )}${queryParam}`;
    }

    if (item.hasSubCategories) {
      return `/subcategories/${actualStyleID}/${getCategoryIDFromPath(
        item.path
      )}${queryParam}`;
    }

    return `/category/${actualStyleID}/${getCategoryIDFromPath(
      item.path
    )}${queryParam}`;
  }

  switch (item.type) {
    case "Home":
      return `/home/${actualStyleID}`;
    case "SubCategories":
      return `/subcategories/${actualStyleID}/${item.categoryID}${queryParam}`;
    case "Category":
      return `/category/${actualStyleID}/${item.categoryID}${queryParam}`;
    case "Person":
      return `/entry/${actualStyleID}/${item.categoryID}/${item.entryID}${queryParam}`;
    default:
      return undefined;
  }
}
